import {
  WSElement,
  WSPage,
  WSPageToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { FilterableTableWorkLogsPayerView } from "../components/TableWorkLogsPayerView/FilterableTableWorkLogsPayerView";

export const RoutePayerLogs = () => {
  const history = useHistory();

  return (
    <WSPage>
      <WSElement mb="2XL">
        <WSPageToolbar title="Work logs" />

        <WSText.ParagraphSm color="gray500">
          See submitted by contractor work, payables are automatically generated
          on your{" "}
          <a
            onClick={() => {
              history.push("/member/invoices/payables");
            }}
          >
            Payables page
          </a>
          .
        </WSText.ParagraphSm>
      </WSElement>

      <FilterableTableWorkLogsPayerView status="submitted" />
    </WSPage>
  );
};
